import axios, { AxiosResponse } from "axios";
import { DefaultApi, Configuration, TasksApi } from "../api-client";
import { Patient } from "./api-mockups/interfaces";
import { TaskStatus, TaskType } from "../interfaces/task";
import { FilterPayload } from "../interfaces/patients";
import { TaskPriority } from "tasks-experience-client";

const baseUrl = process.env.REACT_APP_API_URL;

const instance = axios.create({
  baseURL: baseUrl,
});
const responseBody = (response: AxiosResponse) => response.data;
const requests = {
    get: (url: string, body?: {}) => instance.get(url, { params: body }).then(responseBody),
    post: (url: string, body: {}) => instance.post(url, body).then(responseBody),
    put: (url: string, body: {}) => instance.put(url, body).then(responseBody),
    delete: (url: string) => instance.delete(url).then(responseBody)
}

export const api = {
    getUsers: (params?: FilterPayload): Promise<any> => requests.get("/users", params),
    addNewUsers: (data: any): Promise<any> => requests.post("/users", data),
    addTask: (data: any): Promise<any> => requests.post("/tasks", data),
    getAllTasks: (params: any): Promise<any> => requests.get("/tasks", params),
    addAppointment: (data: any): Promise<any> =>requests.post("/add-appointment", data),
    getAllAppointments: (): Promise<any> => requests.get("/add-appointment"),
    getAllAppointmentsTypes: (): Promise<any> => requests.get('/all-appointment-types'),
    getAppointmentModes: (): Promise<any> => requests.get('/appointment-modes'),
    getAppointmentOccurrenceList: (): Promise<any> => requests.get('/appointment-occurrence'),
    getSearchPatientList: (searchQuery:string): Promise<any> => requests.get(`/search-patient`, searchQuery),
    getSearchCoachList: (searchQuery:string): Promise<any> => requests.get(`/search-coach`, searchQuery),
    getPatientDetailById: (id:number): Promise<Patient> => requests.get(`/patient-details/${id}`),
    getPatients: (params?: FilterPayload): Promise<any> => requests.get("/patients", params),
    getCoaches: (params?: FilterPayload): Promise<any> => requests.get("/coaches", params),
    getNotifications: (): Promise<any> => requests.get('/notifications'),
    deleteNotification: (id:number): Promise<any> => requests.delete(`/notifications/${id}`),
    clearAllNotification: (): Promise<any> => requests.delete(`/notifications`),
    getAllPatients: (): Promise<any> => requests.get('/patient-list'),
    getLoginDetails: (data: any): Promise<any> => requests.get("/login", data),
    getCategories: (): Promise<any> => requests.get(`/tasks/categories`),
    getTaskTypesByCategoryId: (categoryId: number): Promise<any> => requests.get(`/tasks/category/types/${categoryId}`),
    getTaskById: (id:string): Promise<any> => requests.get(`/tasks/${id}`),
    getTaskTypes: (params: any): Promise<TaskType[]> => requests.get(`/tasks/types`, params),
    getTaskStatus: (): Promise<TaskStatus[]> => requests.get(`/tasks/status`),
    getTaskPriority: (): Promise<TaskPriority[]> => requests.get(`/tasks/priority`),
};

    


export const apiClient = new DefaultApi(new Configuration({
    basePath: baseUrl // Base URL of your API
}));
export const apiTaskClient = new TasksApi(new Configuration({
    basePath: baseUrl // Base URL of your API
}));

